module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 volume = volume*1000 ;
__p += '\n';
 solidVolume = solidVolume * 1000 ;
__p += '\n';
 temperature = temperature - 273.15 ;
__p += '\n';
 if (!pour) { ;
__p += '\n';
 topCy = ((-6.18366*Math.pow(10, -8))*Math.pow(volume * 2, 3)+.0000746443*Math.pow(volume * 2, 2)-.0869806*volume * 2+120.02) * .793 ;
__p += '\n';
 topRx = ((-1.5408414*Math.pow(10, -8))*Math.pow(volume * 2, 3)+.000019495413*Math.pow(volume * 2, 2)-.017979381*volume * 2+27.676845) * 1.26 ;
__p += '\n';
 topRy = (7.560756-.001260504*volume * 2) * 1.26 ;
__p += '\n';
 polyAx = ((6.2207*Math.pow(10, -6))*Math.pow(volume * 2, 2)+.013646*volume * 2+2.06043) * .793 ;
__p += '\n';
 polyAy = topCy ;
__p += '\n';
 polyBx = ((-2.44578*Math.pow(10, -8))*Math.pow(volume * 2, 3)+.0000309451*Math.pow(volume * 2, 2)-.0285387*volume * 2+88.9315) * .793 ;
__p += '\n';
 polyBy = topCy ;
__p += '\n<svg xmlns="http://www.w3.org/2000/svg" width="73" height="115" viewBox="0 0 73 115">\n    <defs>\n        <clipPath  transform="translate(0,-2)" id="a">\n            <path d="M17.388 36.357h35.648L71.1 103H.4z"/>\n            <ellipse cx="36.7" cy="103" rx="34.78" ry="11.07"/>\n        </clipPath>\n    </defs>\n    <g fill="none" stroke="#1e1e1e" stroke-width=".3" stroke-linecap="round" stroke-linejoin="round">\n        <path d="M272.4 146.954a91.397 91.397 0 00-11.006-.648c-12.925 0-24.043 2.548-28.976 6.201M290.37 152.507c-1.7-1.26-4.136-2.387-7.127-3.325" transform="matrix(1.1428 0 0 1.07763 -262.132 -67.148)"/>\n    </g>\n        ';
 if (volume > solidVolume) { ;
__p += '\n            <g opacity=".4">\n                <ellipse cx="36.7" cy="' +
((__t = ( topCy )) == null ? '' : __t) +
'" rx="' +
((__t = ( topRx )) == null ? '' : __t) +
'" ry="6.32" fill="' +
((__t = (color)) == null ? '' : __t) +
'"/>\n                <g opacity=".6" fill="' +
((__t = (color)) == null ? '' : __t) +
'">\n                    <polygon\n                    points="' +
((__t = ( polyAx )) == null ? '' : __t) +
', ' +
((__t = ( polyAy )) == null ? '' : __t) +
', ' +
((__t = ( polyBx )) == null ? '' : __t) +
', ' +
((__t = ( polyBy )) == null ? '' : __t) +
', 71.1, 103, .4, 103" />\n                    <ellipse cx="36.7" cy="103" rx="34.78" ry="11.07"/>\n                </g>\n            </g>\n        ';
 } ;
__p += '\n    ';
 if (solidVolume > 0) { ;
__p += '\n        <circle cx="36.7" cy="112.07" r="';
print(Math.pow(solidVolume,1/3)*6);
__p += '" clip-path="url(#a)" fill="' +
((__t = (solidColor)) == null ? '' : __t) +
'"/>\n    ';
 } ;
__p += '\n    <g fill="none" stroke-linecap="round" stroke-linejoin="round">\n        <path d="M266.714 64.285c1.836.15 3.109.108 5.076.472.992.184 1.745.67 1.745.741M247.147 65.894c1.428-.682.266-.162 2.002-.81 2.462-.6 5.17-.861 9.42-1.04 2.112-.089 3.16-.018 5.771.09M273.691 67.66c-1.886 1.519-3.985 2.257-7.336 2.767-4.074.489-7.33.649-12.007.08" stroke="#1e1e1e" stroke-width=".2" transform="matrix(1.1428 0 0 1.07763 -262.132 -67.148)"/>\n        <path d="M236.105 163.025c-4.306-2.35-5.292-5.33-5.292-7.845M291.471 155.18c0 5.03-3.915 11.917-30.293 11.917-9.081 0-15.5-.816-20.014-2.092" stroke="#1e1e1e" stroke-width=".3" transform="matrix(1.1428 0 0 1.07763 -262.132 -67.148)"/>\n        <path d="M247.754 67.42c1.235.408.672.187 2.455.687 2.568.721 6.115 1.167 10.034 1.167 5.748 0 10.337-1.015 12.578-2.345.542-.321.837-.759.895-1.075" stroke="#323232" stroke-width=".5" transform="matrix(1.1428 0 0 1.07763 -262.132 -67.148)"/>\n        <path d="M266.441 130.944a66.355 66.355 0 006.472-.7M266.837 141.133a66.352 66.352 0 006.471-.7M267.016 149.736a66.355 66.355 0 006.471-.7M266.031 118.664a66.35 66.35 0 006.472-.7M265.584 101.66a66.355 66.355 0 006.471-.7" stroke="#000" stroke-width=".5" transform="matrix(1.1428 0 0 1.07763 -262.132 -67.148)"/>\n        <path d="M248.255 68.99c2.653.787 4.06 1.249 4.332 1.325" stroke="#1e1e1e" stroke-width=".2" transform="matrix(1.1428 0 0 1.07763 -262.132 -67.148)"/>\n        <path d="M274.771 70.388V89.14l18.244 66.48c0 4.912-4.097 13.149-31.697 13.149-27.6 0-31.696-8.236-31.696-13.15l17.51-66.479V70.388c-.049-4.309-1.2-2.825-1.337-5.35-.036-1.497 8.785-2.47 14.51-2.47h.276c11.274.023 14.905 1.035 14.904 2.502-.127 2.582-.714.07-.714 5.318z" stroke="#323232" stroke-width=".5" transform="matrix(1.1428 0 0 1.07763 -262.132 -67.148)"/>\n    </g>\n</svg>\n';
 } else { ;
__p += '\n';
 topCx= (.0162663*volume*2+40.9837)*.793 ;
__p += '\n';
 topCy= (105.053-0.0530531*volume*2)*.793 ;
__p += '\n';
 topRx= (.0435435*volume*2+9.95646)*.793 ;
__p += '\n';
 topRy= (0.004004*volume*2+.995996)*.793 ;
__p += '\n';
 polyAx = topCx - topRx/*(53.8237-6.66759*Math.log(volume*2))*.793*/ ;
__p += '\n';
 polyAy = (105.053-0.0530531*volume*2)*.793 ;
__p += '\n';
 polyBx = topCx + topRx/*(.0610611*volume*2+50.9389)*.793*/ ;
__p += '\n';
 polyBy = (105.053-0.0530531*volume*2)*.793 ;
__p += '\n<svg xmlns="http://www.w3.org/2000/svg" height="92" width="118" viewBox="0 0 118 92">\n    <defs>\n        <clipPath id="a">\n            <path transform="translate(0,-2)" d="M2.974 41.236L23.79 83.265l3.965 2.379 3.965 1.586h3.965l3.965-3.145 48.175-42.85z"/>\n        </clipPath>\n    </defs>\n    <g fill="none" stroke="#1e1e1e" stroke-width=".3" stroke-linecap="round" stroke-linejoin="round">\n        <path d="M272.4 146.954a91.397 91.397 0 00-11.006-.648c-12.925 0-24.043 2.548-28.976 6.201M290.37 152.507c-1.7-1.26-4.136-2.387-7.127-3.325" transform="matrix(.48296 1.03572 -.97666 .45543 47.294 -283.657)"/>\n    </g>\n        ';
if (volume > solidVolume) { ;
__p += '\n            <g opacity=".6" fill="' +
((__t = (color)) == null ? '' : __t) +
'">\n                <ellipse cx="' +
((__t = ( topCx )) == null ? '' : __t) +
'" cy="' +
((__t = ( topCy )) == null ? '' : __t) +
'" rx="' +
((__t = ( topRx )) == null ? '' : __t) +
'" ry="' +
((__t = ( topRy )) == null ? '' : __t) +
'" />\n                <polygon points="' +
((__t = (polyAx)) == null ? '' : __t) +
' ' +
((__t = (polyAy)) == null ? '' : __t) +
' 23.79 83.265 27.755 85.644 31.72 87.23 35.685 87.23 39.65 84.085 ' +
((__t = (polyBx)) == null ? '' : __t) +
' ' +
((__t = (polyBy)) == null ? '' : __t) +
'" />\n            </g>\n        ';
 } ;
__p += '\n        ';
 if (solidVolume > 0) { ;
__p += '\n            <circle clip-path="url(#a)" r="';
print(Math.pow(solidVolume,1/3)*6);
__p += '" cy="82.085" cx="39.65" fill="' +
((__t = (solidColor)) == null ? '' : __t) +
'"/>\n        ';
 } ;
__p += '\n    <g fill="none" stroke-linecap="round" stroke-linejoin="round" transform="matrix(.48296 1.03572 -.97666 .45543 47.294 -283.657)">\n        <path d="M266.714 64.285c1.836.15 3.109.108 5.076.472.992.184 1.745.67 1.745.741M247.147 65.894c1.428-.682.266-.162 2.002-.81 2.462-.6 5.17-.861 9.42-1.04 2.112-.089 3.16-.018 5.771.09M273.691 67.66c-1.886 1.519-3.985 2.257-7.336 2.767-4.074.489-7.33.649-12.007.08" stroke="#1e1e1e" stroke-width=".2" />\n        <path d="M236.105 163.025c-4.306-2.35-5.292-5.33-5.292-7.845M291.471 155.18c0 5.03-3.915 11.917-30.293 11.917-9.081 0-15.5-.816-20.014-2.092" stroke="#1e1e1e" stroke-width=".3" />\n        <path d="M247.754 67.42c1.235.408.672.187 2.455.687 2.568.721 6.115 1.167 10.034 1.167 5.748 0 10.337-1.015 12.578-2.345.542-.321.837-.759.895-1.075" stroke="#323232" stroke-width=".5" />\n        <path d="M266.441 130.944a66.355 66.355 0 006.472-.7M266.837 141.133a66.352 66.352 0 006.471-.7M267.016 149.736a66.355 66.355 0 006.471-.7M266.031 118.664a66.35 66.35 0 006.472-.7M265.584 101.66a66.355 66.355 0 006.471-.7" stroke="#000" stroke-width=".5" />\n        <path d="M248.255 68.99c2.653.787 4.06 1.249 4.332 1.325" stroke="#1e1e1e" stroke-width=".2" />\n        <path d="M274.771 70.388V89.14l18.244 66.48c0 4.912-4.097 13.149-31.697 13.149-27.6 0-31.696-8.236-31.696-13.15l17.51-66.479V70.388c-.049-4.309-1.2-2.825-1.337-5.35-.036-1.497 8.785-2.47 14.51-2.47h.276c11.274.023 14.905 1.035 14.904 2.502-.127 2.582-.714.07-.714 5.318z" stroke="#323232" stroke-width=".5" />\n    </g>\n</svg>\n';
 } ;
__p += '\n<div class= "vesselInfo"\n    ';
 if (pour){ ;
__p += '\n     style="text-align:left;"\n    ';
} ;
__p += '\n    >\n    <div class = "vesselName">\n        ' +
((__t = (name)) == null ? '' : __t) +
' <br>\n    </div>\n    ';
 if (showVesselStats) { ;
__p += '\n    <div class = "vesselStats" >\n        ' +
((__t = ( volumeString )) == null ? '' : __t) +
' @</small> ' +
((__t = (temperature.toLocaleString(language, {maximumSignificantDigits: 3, minimumSignificantDigits: 3}))) == null ? '' : __t) +
'&deg;C</sub>\n    </div>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
}